export default __webpack_public_path__ + "static/media/vFil.333818a2.svg";